export const toggleBodyScroll = (status, scrollTop = true) => {
    const viewbox = document.querySelector('html')

    if (status) {
        if (!scrollTop) {
            window.Store.pagescrolled = viewbox.scrollTop
        }

        viewbox.style.height = `${window.innerHeight + 1}px`
        viewbox.style.overflow = 'hidden'
    } else {
        viewbox.style.height = ''
        viewbox.style.overflow = ''

        if (!scrollTop) {
            viewbox.scrollTop = window.Store.pagescrolled
        } else {
            viewbox.scrollTop = 0
        }
    }
}
